import { SelectOption } from '../types/option';
import { fcMovideskHttpClient } from './httpClient';

type BranchDto = { id: string; name: string };
type BranchesResponseDto = {
  customFieldId: number;
  customFieldRuleId: number;
  options: BranchDto[];
};

export async function getBranches(signal?: AbortSignal): Promise<SelectOption[]> {
  const response = await fcMovideskHttpClient.get<BranchesResponseDto>('/branches', { signal });

  return response.options.map((branch) => ({ id: branch.id, label: branch.name }));
}
